<dx-popup
    [visible]="visible"
    (visibleChange)="onVisibleChange($event)"
    [title]="title"
    [showTitle]="true"
    [width]="820"
    height="auto"
    [maxHeight]="'90vh'"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
>
    <div *dxTemplate="let data of 'content'" class="receipt-info-content">
        <dx-load-panel
            [visible]="loading"
            [showPane]="true"
            message="Loading receipt info…"
        ></dx-load-panel>

        @if (reviewNote) {
        <div class="review-banner">{{ reviewNote }}</div>
        } @if (readOnlyReason) {
        <div class="read-only-banner">{{ readOnlyReason }}</div>
        } @else if (existing) {
        <div class="existing-banner">
            Editing the existing request {{ existing.id }} ({{
                existing.status
            }}) — saving replaces its details.
        </div>
        }

        <div class="finder-section">
            <div class="section-caption">
                Look up a company by tax ID or name to fill the fields below
            </div>
            <app-counterparty-finder
                (ctpSelectionChangeEvent)="onCounterpartySelected($event)"
            ></app-counterparty-finder>
        </div>

        <dx-form
            [(formData)]="model"
            [colCount]="2"
            [readOnly]="!!readOnlyReason"
            labelLocation="top"
        >
            <dxi-item itemType="group" caption="Document" [colSpan]="2" [colCount]="2">
                <dxi-item
                    dataField="requestType"
                    editorType="dxSelectBox"
                    [editorOptions]="{
                        items: requestTypes,
                        valueExpr: 'value',
                        displayExpr: 'text',
                        searchEnabled: false
                    }"
                    [label]="{ text: 'Requested document' }"
                >
                    <dxi-validation-rule
                        type="required"
                        message="Document type is required"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item itemType="empty"></dxi-item>
                <dxi-item
                    itemType="simple"
                    [colSpan]="2"
                    [visible]="!!requestTypeHint"
                >
                    <div *dxTemplate class="request-type-hint">
                        {{ requestTypeHint }}
                    </div>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Customer" [colSpan]="2" [colCount]="2">
                <dxi-item
                    dataField="type"
                    editorType="dxSelectBox"
                    [editorOptions]="{ items: invoiceTypes, searchEnabled: false }"
                    [label]="{ text: 'Type' }"
                >
                    <dxi-validation-rule
                        type="required"
                        message="Type is required"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="taxId" [label]="{ text: 'Tax ID' }">
                    <dxi-validation-rule
                        type="pattern"
                        pattern="^[0-9]{13}$"
                        message="13 digits"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                    dataField="legalName"
                    [colSpan]="2"
                    [label]="{ text: 'Legal name' }"
                >
                    <dxi-validation-rule
                        type="required"
                        message="Legal name is required"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                    dataField="branchCode"
                    [label]="{ text: 'Branch code' }"
                    [editorOptions]="{ placeholder: '00000 = head office' }"
                >
                    <dxi-validation-rule
                        type="pattern"
                        pattern="^$|^[0-9]{5}$"
                        message="5 digits; 00000 = head office"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                    dataField="branchName"
                    [label]="{ text: 'Branch name' }"
                ></dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Address" [colSpan]="2" [colCount]="2">
                <dxi-item
                    dataField="line1"
                    [colSpan]="2"
                    [label]="{ text: 'Address' }"
                >
                    <dxi-validation-rule
                        type="required"
                        message="Address is required"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item
                    dataField="subDistrict"
                    [label]="{ text: 'Sub-district' }"
                ></dxi-item>
                <dxi-item
                    dataField="district"
                    [label]="{ text: 'District' }"
                ></dxi-item>
                <dxi-item
                    dataField="province"
                    [label]="{ text: 'Province' }"
                ></dxi-item>
                <dxi-item
                    dataField="postalCode"
                    [label]="{ text: 'Postal code' }"
                >
                    <dxi-validation-rule
                        type="pattern"
                        pattern="^[0-9]{5}$"
                        message="5 digits"
                    ></dxi-validation-rule>
                </dxi-item>
            </dxi-item>

            <dxi-item itemType="group" caption="Contact" [colSpan]="2" [colCount]="2">
                <dxi-item dataField="email" [label]="{ text: 'Email' }">
                    <dxi-validation-rule
                        type="email"
                        message="Not a valid email"
                    ></dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="phone" [label]="{ text: 'Phone' }"></dxi-item>
            </dxi-item>
        </dx-form>

        <div class="popup-actions">
            <dx-button
                text="Cancel"
                stylingMode="outlined"
                [disabled]="saving"
                (onClick)="close()"
            ></dx-button>
            <dx-button
                text="Save"
                type="default"
                icon="save"
                [disabled]="!canSave"
                (onClick)="save()"
            ></dx-button>
        </div>
    </div>
</dx-popup>
